import React, { createContext, FC } from 'react';
import { useTemplatesData } from '../hooks/useTemplatesData';
import { usePageNavigate } from '../hooks/usePageNavigate';
import { AppTemplate } from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import * as Sentry from '@sentry/browser';
import { createHub } from '@wix/fe-essentials/error-monitor';
import { SENTRY_DSN } from '../constants/sentryDSN';

export interface SingleTemplateContextProps {
  template: AppTemplate;
}

export const SingleTemplateContext = createContext<SingleTemplateContextProps>({
  template: {},
});
export const SingleTemplateContextProvider: FC = ({ children }) => {
  const { templates } = useTemplatesData();
  const errorMonitor = createHub({
    dsn: SENTRY_DSN,
    Sentry,
  });
  const { templateId, navigateToMainPage } = usePageNavigate();
  let currentTemplate: AppTemplate;
  const navigateToMainPageOnFirstRender = () => {
    errorMonitor.captureMessage(
      `Navigate to main page on first render of app single template, template id given in url: ${templateId}`,
    );
    navigateToMainPage();
  };

  if (templateId) {
    currentTemplate = templates.find((template) => template.id === templateId);
    if (!currentTemplate || !currentTemplate?.previewUrl) {
      navigateToMainPageOnFirstRender();
    }
  } else {
    navigateToMainPageOnFirstRender();
  }

  return (
    <SingleTemplateContext.Provider value={{ template: currentTemplate! }}>
      {children}
    </SingleTemplateContext.Provider>
  );
};
